import { SIZES } from '../../../constants'
import ArticleImageBox from '../Articles/StyledArticleImageBox'

export default ArticleImageBox.extend`
  flex: 1 1 auto;
  display: -ms-flexbox;
  -ms-flexbox: 1 1 auto;

  @media (min-width: ${SIZES.BREAKPOINT_MD}px) {
    max-width: 128px;
  }
  @media (max-width: ${SIZES.BREAKPOINT_MD - 1}px) {
    margin-top: 30px;
  }
  &.vertical .title-column {
    font-size: 15px;
  }
`
